// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, useRoutes, useLocation } from 'react-router-dom';
import AppRoute from './config/app-route.jsx';
import { slideToggle } from './composables/slideToggle.js';

// bootstrap
import 'bootstrap';

// css
import 'bootstrap-icons/font/bootstrap-icons.css';
import '@fortawesome/fontawesome-free/css/all.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './index.css';
import './scss/styles.scss';

const container = document.getElementById('root');
const root = createRoot(container);

function App() {
  const element = useRoutes(AppRoute);
  const location = useLocation();

  // On every route change, adjust some UI elements if necessary.
  React.useEffect(() => {
    const appElm = document.querySelector('.app');
    if (appElm) {
      appElm.classList.remove('app-sidebar-mobile-toggled');
    }
    const navElm = document.querySelector('.app-top-nav');
    if (navElm && navElm.style.display === 'block') {
      slideToggle(navElm);
    }
  }, [location]);

  return element;
}

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
